import { api, apiGateway, centralCDKApiKey, centralPathOverwrite, } from '../environment.vars';
export var API = api;
export var API_GATEWAY = apiGateway;
export var API_PROFILE = "".concat(API, "/").concat(centralPathOverwrite, "/users/profile");
export var API_USER = function (userID) { return "".concat(API, "/").concat(centralPathOverwrite, "/users/").concat(userID); };
export var API_TRANSLATIONS = "".concat(API, "/translations/translations");
export var API_MISSING_TRANSLATIONS = "".concat(API, "/translations/missing-translations");
export var API_SEARCH_ORDERS = "".concat(API, "/orders/api/v1/orders");
export var API_SEARCH_GLOBAL = "/".concat(centralCDKApiKey, "/global-search");
export var API_APP_SETTING = '/app-setting/setting';
export var API_PATH_PUSH_NOTIFICATION = '/notifications/from-template';
export var API_PATH_TERMS_CONDITION = '/authorizer/terms-conditions';
export var API_UPDATE_USER = "/".concat(centralPathOverwrite, "/users");
export var API_GET_RELEASE_NOTE = '/central/release-notes';
export var API_GET_FAQ = '/central/faqs/list';
//# sourceMappingURL=api.js.map